export const countryFromHost = (host = window.location.host) => {
    const match = host.toLowerCase().match(/(ca|be|es|lu|br)\.(parkindigo|testindigo)\.com/)

    return (match && match[1]) || 'ca'
}

export const countriesFromHost = () => {
    const country = countryFromHost()

    switch (country) {
        case 'fr':
        case 'be':
        case 'lu':
        case 'es':
            return 'FR,BE,LU,ES'
        case 'ca':
            return 'CA'
        case 'br':
            return 'BR'
        default:
            return 'UK'
    }
}

export const defaultLocaleFromHost = () => {
    const country = countryFromHost()

    switch (country) {
        case 'ca':
            return 'en-ca'
        case 'be':
            return 'nl-be'
        case 'es':
            return 'es-es'
        case 'lu':
            return 'fr-fr'
        case 'br':
        case 'pt':
            return 'pt-br'
        default:
            return 'en'
    }
}

export const languageFromPath = (pathname = window.location.pathname) => {
    const match = pathname.toLowerCase().match(/\/([a-z]{2})(?=\/|$)/)

    const country = (match && match[1]) || 'en'

    switch (country) {
        case 'en':
            return 'en-ca'
        case 'be':
            return 'nl-be'
        case 'es':
            return 'es-es'
        case 'lu':
        case 'fr':
            return 'fr-fr'
        case 'br':
        case 'pt':
            return 'pt-br'
        default:
            return 'en-ca'
    }
}

export const isHostCanada = countryFromHost() === 'ca'

export const isBrazil = window.COUNTRY_PURCHASE_FLOW === 'BR'
